/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { DirectorDetailsDTO } from './DirectorDetailsDTO';

export type DirectorsDetailsNigeriaDTO = {
    /**
     * List of company directors
     */
    directors?: Array<DirectorDetailsDTO>;
    /**
     * Overall verification status of all directors
     */
    upgradeTierStepStatus?: DirectorsDetailsNigeriaDTO.upgradeTierStepStatus;
};

export namespace DirectorsDetailsNigeriaDTO {

    /**
     * Overall verification status of all directors
     */
    export enum upgradeTierStepStatus {
        NOT_STARTED = 'NOT_STARTED',
        PENDING = 'PENDING',
        APPROVED = 'APPROVED',
        REJECTED = 'REJECTED',
    }


}

